module.exports = __webpack_public_path__ + "static/media/pumpwhiz-5.4ebe7264.png";